export default "__VITE_ASSET__D9BW6NsY__"